import React, { useCallback, useState, useEffect } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Slider from '@material-ui/core/Slider'
import Input from '@material-ui/core/Input'

const useStyles = makeStyles({
  root: {
    width: 250,
  },
  input: {
    width: 56,
    paddingLeft: 8,
  },
})

const CustomSlider = withStyles({
  disabled: {
    '& .MuiSlider-thumb ': {
      display: 'none',
    },
    '& .MuiSlider-track': {
      backgroundColor: '#e0e0e0',
    },
  },
  root: {
    color: '#F39500',
    height: 4,
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#F39500',
    border: '0px solid currentColor',
    marginTop: -6,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 7px)',
  },
  track: {
    height: 4,
    borderRadius: 0,
    backgroundColor: '#F39500',
  },
  rail: {
    height: 4,
    borderRadius: 0,
  },
  markLabel: {
    fontSize: 10,
  },
})(Slider)

interface Props {
  name: string
  start: number
  end: number
  initialValue: number
  functionChange: React.Dispatch<React.SetStateAction<number>>
  step?: number | null
  prefix?: string
  sufix?: string
  marks?: any
  valueLabelDisplay?: 'off' | 'on' | 'auto'
  showLabel?: boolean
  disabled?: boolean
  inputDisabled?: boolean
  valueFormmated?: string
}

const InputSlider: React.FC<Props> = ({
  name,
  start,
  step = 1,
  end,
  functionChange,
  initialValue,
  prefix,
  sufix,
  marks,
  valueLabelDisplay = 'auto',
  showLabel = false,
  disabled = false,
  inputDisabled = false,
  valueFormmated,
  ...rest
}) => {
  const classes = useStyles()
  const [value, setValue] = useState(initialValue)

  const handleSliderChange = useCallback(
    (event, newValue) => {
      setValue(newValue)
      functionChange(newValue)
    },
    [functionChange],
  )

  const handleInputChange = useCallback(event => {
    setValue(event.target.value === '' ? 0 : Number(event.target.value))
  }, [])

  const handleBlur = useCallback(() => {
    if (value < start) {
      setValue(start)
    } else if (value > end) {
      setValue(end)
    }
  }, [end, start, value])

  useEffect(() => {
    functionChange(value)
  }, [functionChange, value])

  return (
    <div>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs>
          <CustomSlider
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            min={start}
            max={end}
            step={step}
            value={value}
            marks={marks}
            valueLabelDisplay={valueLabelDisplay}
            disabled={disabled}
            {...rest}
          />
        </Grid>
        <Grid item>
          <Input
            className={classes.input}
            value={inputDisabled ? '-' : value}
            margin="dense"
            onChange={handleInputChange}
            onBlur={handleBlur}
            inputProps={{
              step,
              min: start,
              max: end,
              type: 'number',
              'aria-labelledby': 'input-slider',
            }}
            disabled={inputDisabled}
          />
          <span>{!!sufix && sufix}</span>
        </Grid>
      </Grid>
    </div>
  )
}

export default InputSlider
